import { render, staticRenderFns } from "./MailOrganizationInfo.vue?vue&type=template&id=57128e4e&"
import script from "./MailOrganizationInfo.vue?vue&type=script&lang=ts&"
export * from "./MailOrganizationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports